import React, { useEffect, useState } from "react";
import { fetchReportShelterOccupancy } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterVacancyMetricState {
  data?: any[];
}

export const ShelterVacancyMetric = ({ data }: ShelterVacancyMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [vacant, setVacant] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        const empty = data.filter((item: any) => item.occupant_id === null).length;
        setVacant(empty.toString());
        setIsLoading(false);
      } else {
        await getOccupancyData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getOccupancyData = async () => {
    fetchReportShelterOccupancy()
      .then((res: any) => {
        const data = res[0].data;
        const empty = data.filter((item: any) => item.occupant_id === null).length;
        setVacant(empty.toString());
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return <SingleCardMetric title={"Vacant Beds"} total={vacant} isLoading={isLoading} />;
};
